import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { OrderService } from '../../services/order.service';

@Component({
    selector: 'app-order-document',
    template: '',
    standalone: false
})
export class OrderDocumentComponent implements OnInit {
    private amena_order_id: string;

    constructor(private route: ActivatedRoute, private orderService: OrderService) {
        this.amena_order_id = this.route.snapshot.paramMap.get('amena_order_id');
    }

    ngOnInit(): void {
        this.orderService.getDocument(this.amena_order_id).subscribe((resultBlob: Blob) => {
            location.href = URL.createObjectURL(resultBlob);
        });
    }

}
